import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Downloads an Excel file with characteristic groups in matrix format (groups as columns, characteristics as rows)
 * @tags Characteristics
 * @summary Export characteristic groups to Excel
 */
export const ExportCharacteristicGroupsContentType = '' as const;
export type ExportCharacteristicGroupsRequest = void;
export type ExportCharacteristicGroupsResponses = LinkCommonErrorResponses & {
    /**
     * @description Excel file with characteristic groups
     */
    '200': {
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': string;
    };
};
export type ExportCharacteristicGroupsResponseSuccess =
    ExportCharacteristicGroupsResponses['200']['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
export type ExportCharacteristicGroupsSearchParams = undefined;
export type ExportCharacteristicGroupsPathParameters = undefined;
export const ExportCharacteristicGroupsUrl = '/characteristics/groups/export' as const;
export const ExportCharacteristicGroupsMethod = 'GET' as const;
export const getExportCharacteristicGroupsUrl = (_params?: ExportCharacteristicGroupsPathParameters) =>
    ExportCharacteristicGroupsUrl;
